import React from "react";
import { action, observable, toJS } from "mobx";
import { store } from "@store";
import { OkCancelDialogOptions } from "@containers/ConfirmDialog";
import { EmailEditorFormStore, EmailFormData } from "./EmailEditorFormStore";

export type OnSubmitCallback = (emailData: EmailFormData | null) => Promise<any>;

export type RequestEmailEditorOptions = {
  withAttachments?: boolean;
  hideFrom?: boolean;
  smallChips?: boolean;
  inlineRecipients?: boolean;
  withToEditor?: boolean;
  withAddRecipient?: boolean;
  withRemoveRecipient?: boolean;
  customAttachment?: React.ReactNode;
  fromOptions?: string[];

  renderSuggestions?: (options: any) => React.ReactNode;
};

export class EmailEditorDialogStore extends EmailEditorFormStore {
  @observable private _isOpen = false;
  private _options: RequestEmailEditorOptions = {};

  private _onSubmitCallback: OnSubmitCallback | null = null;

  @action requestEmailEditor(
    initialValues: EmailFormData | null,
    cb: OnSubmitCallback,
    options: RequestEmailEditorOptions = {}
  ) {
    if (options.withAttachments) {
      this.allowAttachments = true;
    }
    this._onSubmitCallback = cb;
    this._options = options;
    this.open(initialValues);
  }

  get emailOptions() {
    return this._options;
  }

  get isOpen() {
    return this._isOpen;
  }

  @action.bound open(initialValues?: EmailFormData) {
    this.reset(initialValues);
    this._isOpen = true;
    // this.reset();
  }

  @action.bound close() {
    this._isOpen = false;
  }

  onSubmit = () => {
    return this._onSubmitCallback(toJS(this.values));
  };

  onCancel = () => {
    if (!this.dirty) {
      this._onSubmitCallback && this._onSubmitCallback(null);
      this.close();
      return;
    }

    store()
      .ui.confirmDialog.confirm(new OkCancelDialogOptions())
      .then((result) => {
        if (result === "ok") {
          this._onSubmitCallback && this._onSubmitCallback(null);
          this.close();
        }
      });
  };
}
